import { parse } from '@edicom/common/parser/parse';

export default function ecParserService() {
  return {
    parse,
  };
}
